import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const GooglePayResultMob = () => {
  return <CommonResult />;
};

export default GooglePayResultMob;
